"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = exports.ERROR_MESSAGE = void 0;
exports.ERROR_MESSAGE = {
    INVALID_CALLBACK_URL: "Invalid callback url",
    TOKEN_EXCHANGE_FAIL: "Token exchange failed",
    TOKEN_REFRESH_FAIL: "Token refresh failed",
    AUTH_SESSION_EXPIRED: "Auth session expired",
};
exports.ErrorCode = {
    E0013: "E0013" // Auth session expired 
};
